import React from 'react';
import {
  MessageSquare,
  BarChart3,
  Users,
  Phone,
  LogOut,
  Plug,
  Settings,
  FileBarChart,
  DollarSign,
  UserCheck
} from 'lucide-react';
import { cn } from '../lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { Avatar, AvatarFallback } from './ui/avatar';
import { logout } from '../lib/api';
import { toast } from 'sonner';

const allMenuItems = [
  { id: 'dashboard', icon: BarChart3, label: 'Dashboard', roles: ['admin'] },
  { id: 'conversations', icon: MessageSquare, label: 'Conversas', roles: ['admin', 'supervisor', 'attendant'] },
  { id: 'contacts', icon: Users, label: 'Contatos', roles: ['admin', 'supervisor', 'attendant'] },
  { id: 'reports', icon: FileBarChart, label: 'Relatórios', roles: ['admin', 'supervisor'] },
  { id: 'attendants', icon: UserCheck, label: 'Atendentes', roles: ['admin'] },
  { id: 'instances', icon: Phone, label: 'Instâncias WhatsApp', roles: ['admin'] },
  { id: 'integrations', icon: Plug, label: 'Integrações', roles: ['admin'] },
  { id: 'financial', icon: DollarSign, label: 'Financeiro', roles: ['admin'] },
  { id: 'settings', icon: Settings, label: 'Configurações', roles: ['admin'] },
];

export const Sidebar = ({ activePage, onPageChange, user, onLogout }) => {
  const userRole = user?.role || 'attendant';
  const menuItems = allMenuItems.filter(item => item.roles.includes(userRole));

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
    toast.success('Logout realizado com sucesso');
    onLogout();
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().substring(0, 2);
  };

  return (
    <TooltipProvider>
      <div className="sidebar" data-testid="sidebar">
        <div className="mb-3 -mt-4 -mx-0 w-full flex flex-col items-center">
          <img
            src="/logo.png"
            alt="Integrare+"
            className="w-full h-auto object-cover"
          />
        </div>

        <div className="flex-1 flex flex-col gap-1">
          {menuItems.map((item) => (
            <Tooltip key={item.id}>
              <TooltipTrigger asChild>
                <button
                  data-testid={`nav-${item.id}`}
                  onClick={() => onPageChange(item.id)}
                  className={cn(
                    'sidebar-icon',
                    activePage === item.id && 'active'
                  )}
                >
                  <item.icon size={20} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="right">
                <p>{item.label}</p>
              </TooltipContent>
            </Tooltip>
          ))}
        </div>

        <div className="mt-auto space-y-2">
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={handleLogout}
                className="sidebar-icon text-muted-foreground hover:text-destructive"
                data-testid="logout-btn"
              >
                <LogOut size={20} />
              </button>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p>Sair</p>
            </TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <div className="cursor-default">
                <Avatar className="w-8 h-8">
                  <AvatarFallback className={cn(
                    "text-xs font-bold",
                    user?.status === 'online' ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-600'
                  )}>
                    {getInitials(user?.name)}
                  </AvatarFallback>
                </Avatar>
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p className="font-medium">{user?.name}</p>
              <p className="text-xs text-muted-foreground">{user?.role}</p>
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
    </TooltipProvider>
  );
};

export default Sidebar;
